import { useState, useEffect, useRef } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody, AutocompleteItem, Autocomplete, Select, SelectItem } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModVisiblity, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetailParams } from "../../state/lotMasterSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faClose, faFile, faGem, faPenToSquare, faPlus, faSave, faSquareXmark, faTruckPlane } from "@fortawesome/free-solid-svg-icons";
import { useModalToast } from "../../components/modalToast/ModalToastContext";
import { funNormalizeInput } from "../../Utility/utility";
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { Box, Chip, Drawer } from "@mui/material"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DataGrid } from "@mui/x-data-grid";
import { concat } from "lodash";



const CreateDemand = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode, isMultipleCompany, startDate, endDate } = useSelector((state) => state.company)
    const [submitBtnId, setSubmitBtnId] = useState("")
    const { detailParams, isNewEntry } = useSelector((state) => state.demandEntry);
    const { show } = useModalToast();
    const submitLockRef = useRef(false);//
    const [openDrawer, setOpenDrawer] = useState(false);
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const minAllowedDate = dayjs(startDate)
    const [modSettingParams, setModSettingParams] = useState("")
    const [selectedRowId, setSelectedRowId] = useState("")
    const [rows, setRows] = useState([])
    const maxAllowedDate = dayjs(endDate)
    const [btnLabel, setBtnLabel] = useState("Add")

    const formField = {
        transId: "transId",
        party: "party",
        demandNo: "demandNo",
        demandDate: "demandDate",


    }
    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        const today = dayjs();
        if (key == formField.demandDate)
            acc[key] = today.format("YYYY-MM-DD");

        else acc[key] = ""
        return acc
    }, {})
    const [formData, setFormData] = useState({
        ...emptyFormField
    });

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingDemand",
        inputData: {
            mod_name: ENUM_MOD_NAME.DemandGeneration
        }
    })
    const RowsField = {
        detailId: "detailId",
        locationId: "locationId",
        labId: "labId",
        shape: "shape",
        color: "color",
        purity: "purity",
        fromSize: "fromSize",
        toSize: "toSize",
        fromLength: "fromLength",
        toLength: "toLength",
        fromDiam: "fromDiam",
        toDiam: "toDiam",
        cut: "cut",
        polish: "polish",
        symtry: "symtry",
        flrn: "flrn"

    }
    const noField = [RowsField.fromSize, RowsField.toSize, RowsField.fromLength, RowsField.toLength, RowsField.fromDiam, RowsField.toDiam

    ]
    const getValue = (obj) => {
        if (obj instanceof Set) {
            return Array.from(obj).join(",");
        }

        if (typeof obj === "string") {
            return new Set(
                obj
                    .split(",")
                    .map(item => item.trim())
                    .filter(Boolean)
            );
        }

        return obj;
    };
    const emptyRowsField = Object.keys(RowsField).reduce((acc, key) => {

        if ([RowsField.shape, RowsField.color, RowsField.purity,RowsField.cut,RowsField.polish,RowsField.symtry,RowsField.flrn].includes(key))
            acc[key] = new Set([])
        else acc[key] = ""
        return acc
    }, {})
    const [stockFormData, setStockFormData] = useState({
        ...emptyRowsField
    })
    const { data: detail = [], isPending: isLoading, mutate: filterDetail } = usePost({
        url: apiRoute.demandMaster.fetchEntryDetail,
        queryKey: "fetchDemandMasterdetail",
    });
    const { isPending: isLoadingGridData, data: diamParamMastData = [] } = useFetchWithBody({
        url: apiRoute.stockEntry.paramMasterData,
        queryKey: "fetchMemoGridMasterData",

    })
    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMatserData } = usePost({
        url: apiRoute.demandMaster.entryMasterData,
        queryKey: "fetchMasterData",
        // onSuccessTasks: onSuccessMastData

    })
    let gridData = []
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {

            gridData = detail?.itemDetail.map((item, i) => {

                return {
                    id: ++i,
                    [RowsField.detailId]: item?.DetailId || 0,
                    shape: getValue(item?.Shape || ""),
                    color: getValue(item?.Color || ""),
                    purity: getValue(item?.Purity || ""),
                    [RowsField.locationId]: item?.Lac_Id || '',
                    [RowsField.fromSize]: item?.FromSize || '',
                    [RowsField.toSize]: item?.ToSize || '',
                    [RowsField.fromLength]: item?.FromLnth || '',
                    [RowsField.toLength]: item?.ToLnth || '',
                    [RowsField.fromDiam]: item?.FromDiam || '',
                    [RowsField.toDiam]: item?.ToDiam || '',
                    [RowsField.labId]: item?.LabId || '',
                    [RowsField.cut]:getValue(item?.Cut || ''),
                    [RowsField.polish]:getValue(item?.Polish || ''),
                    [RowsField.symtry]:getValue(item?.Symtry || ''),
                    [RowsField.flrn]:getValue(item?.Flrcn || '')



                }
            })


        }
    }
    
    useEffect(() => {
        if (modSetting && modSetting?.length > 0) {
            const modData = modSetting


            setModSettingParams({
                Visibility: {
                    [RowsField.shape]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Shape, modData) ?? false,
                    [RowsField.color]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Color, modData) ?? false,
                    [RowsField.purity]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Purity, modData) ?? false,
                    [RowsField.fromSize]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Size, modData) ?? false,
                    [RowsField.toSize]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Size, modData) ?? false,
                    [RowsField.fromLength]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Length, modData) ?? false,
                    [RowsField.toLength]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Length, modData) ?? false,
                    [RowsField.fromDiam]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Diameter, modData) ?? false,
                    [RowsField.toDiam]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Diameter, modData) ?? false,
                    [RowsField.cut]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Cut, modData) ?? false,
                    [RowsField.polish]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Polish, modData) ?? false,
                    [RowsField.flrn]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Flrcn, modData) ?? false,
                    [RowsField.labId]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Lab, modData) ?? false,
                    [RowsField.symtry]: getModVisiblity(ENUM_MOD_PARAMETER.DemandGeneration.Symtry, modData) ?? false,


                },
                Mandatory: {
                    [RowsField.shape]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Shape, modData) ?? false,
                    [RowsField.color]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Color, modData) ?? false,
                    [RowsField.purity]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Purity, modData) ?? false,
                    [RowsField.fromSize]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Size, modData) ?? false,
                    [RowsField.toSize]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Size, modData) ?? false,
                    [RowsField.fromLength]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Length, modData) ?? false,
                    [RowsField.toLength]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Length, modData) ?? false,
                    [RowsField.fromDiam]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Diameter, modData) ?? false,
                    [RowsField.toDiam]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Diameter, modData) ?? false,
                    [RowsField.cut]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Cut, modData) ?? false,
                    [RowsField.polish]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Polish, modData) ?? false,
                    [RowsField.flrn]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Flrcn, modData) ?? false,
                    [RowsField.labId]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Lab, modData) ?? false,
                    [RowsField.symtry]: getModMandatory(ENUM_MOD_PARAMETER.DemandGeneration.Symtry, modData) ?? false,

                },


            })
        }

    }, [modSetting])
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        filterMatserData({
            data: {
                compcode: compCode.join(",")
            }
        })
    }, [])
    const handleAddRow = () => {
        setSelectedRowId("")

        setStockFormData({ ...emptyRowsField })
        setOpenDrawer(true)
        setBtnLabel("Add")

    }
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        const rearrangedRows = updatedRows.map((row, index) => {
            return {
                ...row,
                id: index + 1
            } // Reassign IDs to start from 1 again
        })
        setRows(rearrangedRows)
        //setAllRows(rearrangedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])

    }
    const handleEditRow = (id) => {
        const editRow = rows.filter((row) => row.id == id)
        setStockFormData(...editRow)
        setSelectedRowId(id)
        setOpenDrawer(true)
        setBtnLabel("Edit")

    }
    const setColumnVisiblity = (column) => {
        if (column == RowsField.locationId)
            return true
        else {
            if (modSetting && modSetting?.length > 0) {
                return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
            }
            else
                return true
        }
    }
    const setColumnRequired = (column) => {
        if (modSettingParams && modSettingParams?.Mandatory) {
            return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false
        }
        else
            return false
    }
    const inputBoxes = {
        Row1: [
            {
                id: formField.party,
                name: formField.party,
                placeholder: "Party Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Name",
                itemvalue: "Party_Name",
                isrequired: false,
            },
            {
                id: formField.party,
                name: formField.party,
                placeholder: "New party",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row2: [
            {
                id: formField.demandNo,
                name: formField.demandNo,
                placeholder: "Demand No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.demandDate,
                name: formField.demandDate,
                placeholder: "Demand Date.",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },

        ],

    }
    const stockInputBox = {
        Row1: [


            {
                id: RowsField.locationId,
                name: RowsField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data:diamParamMastData?.stkMaster || [],
                itemkey: "AC_ID",
                itemvalue: "AC_DESC",
                isrequired: true,
            },
            {
                id: RowsField.labId,
                name: RowsField.labId,
                placeholder: "Lab",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data:diamParamMastData.labMaster || [],
                itemkey: "LabId",
                itemvalue: "LabId",
                isrequired: true,
            },

        ],
        Row2: [
            {
                id: RowsField.shape,
                name: RowsField.shape,
                placeholder: "Shape",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: diamParamMastData?.shapeMaster || [],
                itemkey: "S_Name",
                itemvalue: "S_Name",
                isrequired: false,
            },
            {
                id: RowsField.color,
                name: RowsField.color,
                placeholder: "Color",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: diamParamMastData?.colorMaster || [],
                itemkey: "Sh_Name",
                itemvalue: "Sh_Name",
                isrequired: false,
            },

        ],
        Row3: [
            {
                id: RowsField.purity,
                name: RowsField.purity,
                placeholder: "Purity",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: diamParamMastData?.purityMaster || [],
                itemkey: "Q_Name",
                itemvalue: "Q_Name",
                isrequired: false,
            },
            {
                id: RowsField.cut,
                name: RowsField.cut,
                placeholder: "Cut",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: diamParamMastData?.cutMaster || [],
                itemkey: "CutId",
                itemvalue: "Cut_Name",
                isrequired: false,
            },


        ],
        Row4: [
            {
                id: RowsField.polish,
                name: RowsField.polish,
                placeholder: "polish",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: diamParamMastData?.cutMaster || [],
                itemkey: "CutId",
                itemvalue: "Cut_Name",
                isrequired: false,
            },
            {
                id: RowsField.symtry,
                name: RowsField.symtry,
                placeholder: "Symtry",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: diamParamMastData?.cutMaster || [],
                itemkey: "CutId",
                itemvalue: "Cut_Name",
                isrequired: false,
            },


        ],
        Row5: [
            {
                id: RowsField.flrn,
                name: RowsField.flrn,
                placeholder: "Flrcn",
                type: ENUM_INPUT_TYPE.select,
                size: "sm",
                label: "",
                data: diamParamMastData?.flrnMaster || [],
                itemkey: "Flrn_Code",
                itemvalue: "Flrn_Name",
                isrequired: false,
            },
        ],
        Row6: [
            {
                id: RowsField.fromSize,
                name: RowsField.fromSize,
                placeholder: "From Size.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: RowsField.toSize,
                name: RowsField.toSize,
                placeholder: "To Size.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            // ],
            // Row5: [
            {
                id: RowsField.fromLength,
                name: RowsField.fromLength,
                placeholder: "From Length",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: RowsField.toLength,
                name: RowsField.toLength,
                placeholder: "To Length",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ],
        Row7: [
            {
                id: RowsField.fromDiam,
                name: RowsField.fromDiam,
                placeholder: "From Diam.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: RowsField.toDiam,
                name: RowsField.toDiam,
                placeholder: "To Diam.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },

        ]

    }
    
    const handleDelet = (key, name) => {
        if (name == 'shape') {
            const newFilter = stockFormData[name]
            newFilter.delete(key)
            setStockFormData({ ...stockFormData, [name]: new Set(newFilter) });
        }
        else if (name == 'color') {
            const newFilter = stockFormData[name]
            newFilter.delete(key)
            setStockFormData({ ...stockFormData, [name]: new Set(newFilter) });
        }

    }
    const handleSelectionChnage = (keys, name) => {
        setStockFormData({ ...stockFormData, [name]: keys })

    }
    const handleAutoCompleteChange = (value, name) => {
        if (name == RowsField.locationId || name == RowsField.labId) {
            setStockFormData({ ...stockFormData, [name]: value })
        }
        else {
            setFormData({
                ...formData,
                [name]: value,

            })
        }
    }

    const itemGridHeadClass = "bill-grid-style"
    const columns = [
        {
            field: "id",
            headerName: "Action",
            width: 70,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>

                    <div className="flex justify-evenly" ><h6> {row.id}</h6>
                        <strong>
                            <FontAwesomeIcon
                                color="red"
                                className={` mx-2 cursor-pointer`}
                                onClick={() => handleDeleteRow(row.id)}
                                icon={faSquareXmark}
                            ></FontAwesomeIcon>

                            <FontAwesomeIcon
                                color="green"
                                className={`  cursor-pointer`}
                                onClick={() => handleEditRow(row.id)}
                                icon={faPenToSquare}
                            ></FontAwesomeIcon>


                        </strong>
                    </div>
                </div>
            ),
        },

        {
            field: RowsField.shape,
            headerName: "Shape",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {getValue(row[RowsField.shape])
                    }
                </div>)
        },
        {
            field: RowsField.color,
            headerName: "Color",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {getValue(row[RowsField.color])
                    }
                </div>)
        },
        {
            field: RowsField.Purity,
            headerName: "Purity",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {getValue(row[RowsField.purity])
                    }
                </div>)
        },
        {
            field: RowsField.fromSize,
            headerName: "Size",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {
                        row[RowsField.fromSize]} - {row[RowsField.toSize]}
                </div>)
        },

        {
            field: RowsField.fromLength,
            headerName: "Length",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.fromLength]} - {row[RowsField.toLength]
                    }
                </div>)
        },
        {
            field: RowsField.fromDiam,
            headerName: "Diam",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.fromDiam]} - {row[RowsField.toDiam]
                    }
                </div>)
        },
        {
            field: RowsField.labId,
            headerName: "Lab",
            minWidth: 100,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "center",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.labId]
                    }
                </div>)
        },

    ]
    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                [formField.demandDate]: cdate,
            };
        });

    }
    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        if (!parsed.isValid()) {
            show("Invalid date format. Use DD/MM/YYYY")
            // toast.error("Invalid date format. Use DD/MM/YYYY", {
            //     position: "top-center",
            //     className: "toast-error"
            // });
            return;
        }

        // ❌ Out of allowed range
        if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
            show(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`)
            // toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
            //     position: "top-center",
            //     className: "toast-error"
            // });
            setFormData({ ...formData, [name]: null })
            return;
        }

        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");

        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });

    };

    useEffect(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {

            filterDetail({
                data: {
                    transactionid: detailParams.trans_id,
                    compcode: detailParams.comp_code
                }
            })
        }
    }, [detailParams]);

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            setRows(gridData)
            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                setFormData({
                    party: detail?.itemData[0].PartyName || "",
                    demandNo: detail?.itemData[0].Dem_No || "",
                    demandDate: detail?.itemData[0].Dem_Date || null,
                    transId: detail?.itemData[0].TransactionId || 0,
                });
                // console.log(shapeDetails.S_Code, isNewEntry, formData)
            }

        }
    }, [detail]);

    console.log(rows, "row")
    const isDuplicateExcludingId = (target, arr) => {
        return arr.some(item => {
            // Skip the same object by id
            const excludeKey = [RowsField.pcs, RowsField.weight, RowsField.weight, RowsField.amount]
            if (item.id === target.id) return false;

            // Compare all keys except 'id'
            return Object.keys(target).every(key => {
                if (selectedRowId && selectedRowId > 0) {
                    if (excludeKey.includes(key) && key != 'id') return true;
                }
                else
                    if (excludeKey.includes(key)) return true;
                return item[key] === target[key];
            });
        });
    };
    const handleAddStock = () => {
        const validate_form = validateForm()

        if (validate_form) {

            // let isDuplicate = false
            // isDuplicate = isDuplicateExcludingId(stockFormData, rows)
            console.log(selectedRowId)
            // if (!isDuplicate) {
            if (selectedRowId && selectedRowId != "") {
                const currentDataIndex = rows.findIndex((ele) => ele.id == selectedRowId);
                const updateData = { ...rows[currentDataIndex], ...stockFormData }
                const newData = [...rows]
                newData[currentDataIndex] = updateData
                setSelectedRowId("")
                setRows(newData)
                //  setAllRows(newData)
                setOpenDrawer(false)


            }
            else {

                const newRow = { id: rows.length + 1, ...stockFormData }
                console.log("gu", newRow, rows.length + 1)
                setRows([...rows, newRow])
                //setAllRows([...allRows, newRow])
                const lastRow = stockFormData
                setStockFormData({ ...lastRow, shape: new Set([]) })
                toast.success("Demand Stock Added.....", {
                    "position": "top-center",
                    onClose: () => {
                        const pktInput = document.querySelector("#shape");
                        if (pktInput && typeof pktInput.focus === 'function') {
                            pktInput.focus();
                        }
                        //if (refInputPktNo.current && typeof refInputPktNo.current.focus === 'function')
                        // refInputPktNo.current.focus();
                    }
                })

            }

            // }
            // else {
            //     toast.error("Duplicate values not allow", {
            //         "position": "top-center"
            //     })
            // }
        }
        else {
            if (!toast.isActive('toats_chkreqrd')) {
                toast.error("Fill all required values", {
                    "position": "top-center",
                    "className": "toast-error",
                    toastId: "toats_chkreqrd",
                })
            }
        }
    }
    const handleChange = (e) => {
        const { value, name } = e.target
        if ([formField.party, formField.demandNo].includes(name))
            setFormData({ ...formData, [name]: value });
        else {
            if (funValidateNoInput(value))
                setStockFormData({ ...stockFormData, [name]: value });
        }
    };

    const { mutate: funAddUpdate, isPending, isError } = usePost({
        queryKey: "DemandMasterAddUpdate",
        url: apiRoute.demandMaster.add_update,
        onSuccessTasks: () => {
            dispatch(resetDetailParams());
            submitLockRef.current = false;
            if (submitBtnId == 'btnSaveNew') {
                setFormData({
                    ...emptyFormField
                })
            }
            else
                navigate(linksUrl.master.demand.demandMaster);
        },
    });


    const { mutate: funChkDupDemNo } = usePost({
        queryKey: "checkDemandCode",
        url: apiRoute.demandMaster.checkDemandNo,
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {
                show("Demand No Exists Enter Another")
                setFormData({ ...formData, [formField.demandNo]: "" })
            }

        }
    });

    const handleBlur = (e) => {
        const { name, value } = e.target;
        funChkDupDemNo({
            data: {
                dem_no: value,
                comp_code: compCode.join(",")
            }
        })

    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (stockFormData.locationId.trim() == "") {
            newErrors[RowsField.locationId] = "Location required"
        }

        if (setColumnRequired(RowsField.shape)) {
            if (stockFormData[RowsField.shape].size == 0) {
                newErrors[RowsField.shape] = "Shape required"
            }
        }
        if (setColumnRequired(RowsField.color)) {
            if (stockFormData[RowsField.color].size == 0) {
                newErrors[RowsField.color] = "Color required"
            }
        }
        if (setColumnRequired(RowsField.purity)) {
            if (stockFormData[RowsField.purity].size == 0) {
                newErrors[RowsField.purity] = "Purity required"
            }
        }
        if (setColumnRequired(RowsField.fromSize)) {
            if (String(stockFormData[RowsField.fromSize]).trim() == "")
                newErrors[RowsField.fromSize] = "From Size required"
            if (String(stockFormData[RowsField.toSize]).trim() == "")
                newErrors[RowsField.toSize] = "To Size required"

        }
        if (setColumnRequired(RowsField.fromLength)) {
            if (String(stockFormData[RowsField.fromLength]).trim() == "")
                newErrors[RowsField.fromLength] = "From Length required"
            if (String(stockFormData[RowsField.toLength]).trim() == "")
                newErrors[RowsField.toLength] = "To Length required"

        }
        if (setColumnRequired(RowsField.fromDiam)) {
            if (String(stockFormData[RowsField.fromDiam]).trim() == "")
                newErrors[RowsField.fromDiam] = "From Diam required"
            if (String(stockFormData[RowsField.toDiam]).trim() == "")
                newErrors[RowsField.toDiam] = "To Diam required"

        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [stockFormData])
    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        const newData = rows.map((ele) => {
            return { ...ele, shape: getValue(ele.shape), color: getValue(ele.color), purity: getValue(ele.purity)
                ,cut:getValue(ele.cut),polish:getValue(ele.polish),symtry:getValue(ele.symtry),flrn:getValue(ele.flrn)
             }
        })
        console.log(newData, deletedItemRows, "df")
        funAddUpdate({
            data: {
                comp_code: compCode.join(","),
                trans_id: formData.transId,
                party_name: formData.party,
                dem_no: formData.demandNo,
                dem_date: formData.demandDate,
                item_list: newData,
                deleteditem_list: deletedItemRows,
                login_userid: user.username,
                rec_status: !isNewEntry ? 1 : 2,
                fystart_date: dayjs(startDate).format("YYYY-MM-DD"),
                fyend_date: dayjs(endDate).format("YYYY-MM-DD"),

            }
        });

    };



    if (isLoading || isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <MainContainer
            pageName="Demand Generation"
            breadcrumbs={["Master", "Demand Generation"]}
            prevPage={{ show: true, onClick: () => navigate(linksUrl.master.demand.demandMaster) }}
        >
            {/* <Card className="p-6"> */}
            <Card shadow="sm" radius="sm" className="mb-3  h-[calc(100vh-118px)]  overflow-y-auto">

                <form onSubmit={handleSubmit}>
                    <CardBody>
                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    {/* ${isMobile ? 'flex-wrap' : ''} */}
                                    <div className={`flex flex-wrap sm:flex-nowrap md:flex-nowrap    gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <>
                                                        <Autocomplete
                                                            size="md"
                                                            name={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            label={item?.placeholder}
                                                            eventResizeFeature={true}
                                                            selectionMode="single"
                                                            showScrollIndicators={true}
                                                            labelPlacement={"outside"}
                                                            placeholder={item.placeholder}
                                                            isRequired={item.isrequired}
                                                            isLoading={isLoadingData}
                                                            menuTrigger={"input"}
                                                            className="max-w-23"
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                            isClearable={false}
                                                            isVirtualized
                                                            //isReadOnly={disbaleInput() ? true : false}
                                                            defaultItems={
                                                                item.data ? item.data : []
                                                            }
                                                            onSelectionChange={(e) =>
                                                                handleAutoCompleteChange(e, item.name)
                                                            }
                                                            color={item.id == formField.bookId ? "success" : item.id == formField.party ? "danger" : "warning"}
                                                            //onChange={handleFormSelectionChange}
                                                            selectedKey={formData[item.name]}
                                                        >
                                                            {(list) => (
                                                                <AutocompleteItem

                                                                    key={list[item.itemkey]}
                                                                >
                                                                    {list[item.itemvalue]}
                                                                </AutocompleteItem>
                                                            )}
                                                        </Autocomplete>

                                                    </>
                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                //isReadOnly={disbaleInput() ? true : false}
                                                                minDate={minAllowedDate}
                                                                maxDate={maxAllowedDate}
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name], "YYYY-MM-DD")
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => handleDateChange(newValue)}
                                                                // setFormData((prev) => {
                                                                //     return {
                                                                //         ...prev,
                                                                //         [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                //             dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                //     };
                                                                // });
                                                                //}}
                                                                //isRequired={item.required}
                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: {
                                                                        size: "small", error: errors[item.name], helperText: errors[item.name],
                                                                        onBlur: (e) => handleDateBlur(e, item.name), required: true
                                                                    },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : (

                                                    <Input
                                                        type={item.type}
                                                        name={item.name}
                                                        id={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        placeholder={item.placeholder}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        isRequired={item.isrequired}
                                                        value={formData[item.name]}
                                                        variant="bordered"
                                                        onChange={(e) => handleChange(e)}
                                                        onBlur={(e) => handleBlur(e)}
                                                        // isReadOnly={(item.name == formField.vouNo || disbaleInput())
                                                        //     && (item.name != formField.demandNo) ? true : false}
                                                        size={"md"}
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                    ></Input>
                                                )
                                            )
                                        }
                                    </div>
                                </div>
                            ))
                        }
                        <div className="flex justify-between items-center">
                            <Button size="sm" color="success" radius="sm" className="text-white cursor-pointer  text-xs bg-emerald-600" startContent={<FontAwesomeIcon color="white" icon={faGem} />}
                                onPress={handleAddRow}>
                                ADD DEMAND STOCK
                            </Button>
                            {/* <h6 className="text-sm text-green-700" >Total Items : {rows && rows.length > 0 ? rows.length : 0}</h6> */}
                        </div>
                        <Drawer open={openDrawer} anchor="top">
                            {/* <FontAwesomeIcon onClick={() => setOpenDrawer(false)} className=" p-3 cursor-pointer text-blue-800 text-3xl absolute right-0" icon={faSquareXmark} /> */}

                            <div className="text-center font-semibold uppercase p-1 text-gray-700 border-b-2 border-orange-500">
                                Demand Stock Item
                            </div>
                            <div className="p-5">
                                {
                                    Object.keys(stockInputBox).map((key, ind) => (
                                        <div key={key + ind}>
                                            {/* ${isMobile ? 'flex-wrap' : ''} */}
                                            <div className={`flex flex-wrap sm:flex-nowrap md:flex-nowrap    gap-4 align-top items-baseline mb-2 `}>
                                                {
                                                    stockInputBox[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            setColumnVisiblity(item.name) &&
                                                            <Select
                                                                size="md"
                                                                name={item.name}
                                                                label={item?.placeholder}
                                                                color="default"
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                eventResizeFeature={true}
                                                                selectionMode="multiple"
                                                                labelPlacement="outside"
                                                                showScrollIndicators={true}
                                                                placeholder={"--select--"}
                                                                className="w-full "
                                                                classNames={{
                                                                    label: "text-xs font-semibold",
                                                                }}
                                                                isClearable={true}
                                                                variant="bordered"
                                                                isVirtualized
                                                                items={
                                                                    item.data ? item.data : []
                                                                }
                                                                renderValue={(items) => {
                                                                    return (
                                                                        <div className="flex gap-2 w-full" >
                                                                            {items.map((selitem) => (
                                                                                <div key={selitem[item.itemkey]} className="flex  text-xs">
                                                                                    <Chip
                                                                                        key={selitem[item.itemkey]}
                                                                                        label={selitem.data[item.itemvalue]}
                                                                                        onDelete={() => handleDelet(selitem.key, item.name)}
                                                                                        size="small"
                                                                                        color="secondary"
                                                                                        variant="outlined"
                                                                                        sx={{ height: 22, fontSize: "10px" }}
                                                                                    />
                                                                                </div>
                                                                                // <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.Sh_Code}><strong style={{ fontSize: "0.6rem" }} className="text-blue-800"  > {item.data.Sh_Name}</strong></Chip>
                                                                                // <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'color')} icon={faCircleXmark} /></div>
                                                                            ))}
                                                                        </div>
                                                                    );
                                                                }}
                                                                onSelectionChange={(e) => handleSelectionChnage(e, item.name)}
                                                                selectedKeys={stockFormData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <SelectItem
                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </SelectItem>
                                                                )}
                                                            </Select>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                            setColumnVisiblity(item.name) &&

                                                            <Autocomplete
                                                                size="md"
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                isLoading={isLoadingData}
                                                                menuTrigger={"input"}
                                                                className="max-w-23"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                //isReadOnly={disbaleInput() ? true : false}
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, item.name)
                                                                }
                                                                color={item.id == formField.bookId ? "success" : item.id == formField.party ? "danger" : "warning"}
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={stockFormData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>


                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                            <></>
                                                        ) : (
                                                            setColumnVisiblity(item.name) &&
                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                id={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isRequired={item.isrequired}
                                                                value={stockFormData[item.name]}
                                                                variant="bordered"
                                                                onChange={(e) => handleChange(e)}
                                                                onBlur={(e) => handleBlur(e)}
                                                                // isReadOnly={(item.name == formField.vouNo || disbaleInput())
                                                                //     && (item.name != formField.demandNo) ? true : false}
                                                                size={"md"}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="pb-5 text-center justify-center flex gap-4">
                                <Button
                                    color="success"
                                    size="sm"
                                    variant="shadow"
                                    className=""
                                    onPress={handleAddStock}
                                    startContent={<FontAwesomeIcon icon={faPlus} />}
                                >
                                    {btnLabel}
                                </Button>
                                <Button
                                    color="danger"
                                    size="sm"
                                    variant="shadow"
                                    className=""
                                    onPress={() => setOpenDrawer(false)}
                                    startContent={<FontAwesomeIcon icon={faClose} />}
                                >
                                    Close
                                </Button>
                            </div>
                        </Drawer>
                        {rows && rows?.length > 0 ? (
                            <>

                                <Box sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        editMode="row"
                                        columnHeaderHeight={30}
                                        rowHeight={30}
                                        disableColumnSorting={true}
                                        disableColumnMenu={true}
                                        getRowClassName={(params) => {
                                            if (params.id == selectedRowId)
                                                return 'select-row'
                                            return 'row-class';
                                        }}

                                        // getRowClassName={getRowClassName}
                                        sx={{
                                            '& .MuiDataGrid-columnHeaders': {
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 1, // Make sure the headers are above the rows when scrolling

                                            },
                                            '& .select-row': {
                                                backgroundColor: "#ebe8e8"
                                            },
                                            '& .row-class': {
                                                fontSize: "12px"
                                            },
                                            '& .sticky-row': {
                                                position: 'sticky',
                                                bottom: 0,
                                                color: "#FFFFFF",
                                                backgroundColor: '#424242f5',
                                                zIndex: 10,
                                            },
                                            '& .sticky-row:hover': {
                                                backgroundColor: "#424242f5"
                                            }
                                        }}
                                        columnVisibilityModel={{
                                            [RowsField.shape]: setColumnVisiblity(RowsField.shape),
                                            [RowsField.color]: setColumnVisiblity(RowsField.color),
                                            [RowsField.purity]: setColumnVisiblity(RowsField.purity),
                                            [RowsField.fromSize]: setColumnVisiblity(RowsField.fromSize),
                                            [RowsField.toSize]: setColumnVisiblity(RowsField.toSize),
                                            [RowsField.fromLength]: setColumnVisiblity(RowsField.fromLength),
                                            [RowsField.toLength]: setColumnVisiblity(RowsField.toLength),
                                            [RowsField.fromDiam]: setColumnVisiblity(RowsField.fromDiam),
                                            [RowsField.toDiam]: setColumnVisiblity(RowsField.toDiam),
                                        }}

                                    />

                                </Box>

                            </>
                        ) : (
                            ""
                        )}
                    </CardBody>
                    {/* //stickyBottomClass */}
                    <div className="">
                        <div className="justify-center flex items-center gap-4">
                            {/* <div className="justify-center flex gap-5 mt-5"> */}
                            <Button
                                color="primary"
                                type="submit"
                                id="btnSave"
                                size="sm"
                                variant="shadow"
                                // isDisabled={isExcelImport?isLoadingDupPktList:false}
                                isLoading={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit
                            </Button>

                            <Button
                                color="danger"
                                variant="shadow"
                                size="sm"
                                tabIndex={-1}
                                //onPress={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </form>




            </Card>
        </MainContainer>
    );
};

export default CreateDemand;

